export const SCHOOLS_TABS = ['Summary', 'School forms', 'Pupils', 'Users', 'School details change logs'];

export const SCHOOL_TYPE = {
  SCHOOL: 'School',
  SCHOOL_UNION: 'SchoolUnion',
};
